export default __webpack_public_path__ + "static/media/blueSaveIcon.84cb6f63.svg";